import { setGetBalanceCorrectionByIdAction } from '../action';
import { getBalanceCorrectionById } from '../api/getBalanceCorrectionById';

export const setGetBalanceCorrectionById = (params, callback) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getBalanceCorrectionById(params);
            dispatch(setGetBalanceCorrectionByIdAction(data.data))

            if (callback) {
                callback();
            }
        } catch(error) {
            if (error?.response?.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}